import { POSTAL_CODE_FORMAT } from "~~/constants/checkout";

export const validatePostalCode = (country, postalCode) => {

  if (!country) {

    return false;

  }

  const postalCodeRegex = POSTAL_CODE_FORMAT[country.toLowerCase()];

  if (!postalCodeRegex) {

    return true;

  }

  if (!postalCode) {

    return true;

  }

  return postalCodeRegex.test(String(postalCode));

};
